import script from "./DesempenhoGeralAlunosView.vue?vue&type=script&setup=true&lang=js"
export * from "./DesempenhoGeralAlunosView.vue?vue&type=script&setup=true&lang=js"

import "./DesempenhoGeralAlunosView.vue?vue&type=style&index=0&id=de1f47fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de1f47fa"]])

export default __exports__